/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import { format } from 'date-fns';
import { injectIntl } from 'react-intl';
import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import ShowIf from 'loracoms/ShowIf';
import Editable from 'loracoms/Editable';
import { editToken } from 'loraapi/token';
import styles from './styles.scss';

class TableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: props.list,
      editName: false,
      editData: { name: props.list.name, id: props.list.token },
      ainimation: false,
      errors: ErrorSet.createEmpty()
      .add('FE_EMPTY', 'green.min')
      .add('FE_EMPTY', 'green.max')
      .add('FE_EMPTY', 'yellow.min')
      .add('FE_EMPTY', 'yellow.max')
      .add('FE_EMPTY', 'red.min')
      .add('FE_EMPTY', 'red.max'),
    };
    this.intlMsg = new IntlMsg(props.intl, 'accountcenter.manageview');
    this.handleEditName = this.handleEditName.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleSubmitName = this.handleSubmitName.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const { list } = nextProps;
    if (list !== this.props.list) {
      this.setState({ list });
    }
  }
  handleEditName() {
    const { list: { name }, editData: { id } } = this.state;
    this.setState({ editName: true, editData: { name, id } });
  }
  handleCancelEdit() {
    const { list: { name }, editData: { id }, errors } = this.state;
    this.setState({ editName: false, editData: { name, id }, errors: errors.remove('name') });
  }
  handleChangeName(data) {
    const { errors } = this.state;
    this.setState({ editData: data, errors: errors.remove('name') });
  }
  handleSubmitName() {
    const { editData: { id, name }, list, errors } = this.state;
    if (_.trim(name).length !== 0) {
      editToken(id, name)
        .then(() => {
          this.setState({ editName: false, list: Object.assign(list, { name }) });
        })
        .catch(() => {});
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  }
  handleDelete() {
    const { onHandleDelete } = this.props;
    const { list: { token, name } } = this.state;
    onHandleDelete(token, name);
  }
  render() {
    const { list, editName, editData = {}, errors } = this.state;
    const { showAnimation } = this.props;
    const editTp = <Tooltip id="tooltip-ed">{this.intlMsg.msg('tablecolumn.edit')}</Tooltip>;
    const editTpDelete = <Tooltip id="tooltip-ed">{this.intlMsg.msg('tablecolumn.delete')}</Tooltip>;
    const animation = this.props.index === 0 && showAnimation ? `animated slideInLeft ${styles['newly-created']}` : '';
    return (
      <tr className={animation}>
        <td>
          <Editable
            id="name"
            edit={editName}
            data={editData}
            value={list.name}
            onChange={this.handleChangeName}
            formatter={() => <span>{list.name}</span>}
            error={this.intlMsg.errorMsg(errors.get('name'))}
            errorPlacement={'top'}
          />
          <ShowIf if={!editName}>
            <OverlayTrigger placement="top" overlay={editTp}>
              <Link onClick={this.handleEditName} className={styles.edit}>
                <span className={`halflings halflings-pencil ${styles.gray}`} />
              </Link>
            </OverlayTrigger>
          </ShowIf>
          <ShowIf if={editName}>
            <span className={styles.actions}>
              <Link onClick={this.handleSubmitName} className={styles.ok}>
                <span className="halflings halflings-ok" />
              </Link>
              <Link onClick={this.handleCancelEdit} className={styles.cancel}>
                <span className="halflings halflings-remove" />
              </Link>
            </span>
          </ShowIf>
        </td>
        <td>{list.token}</td>
        <td>{format(list.createdAt, 'YYYY-MM-DD HH:mm:ss')}</td>
        <td>
          <OverlayTrigger placement="top" overlay={editTpDelete}>
            <Link
              className={styles.edit}
              onClick={this.handleDelete}
            >
              <i className={`halflings halflings-trash ${styles.deleteIcon} ${styles.icon}`} />
            </Link>
          </OverlayTrigger>
        </td>
      </tr>
    );
  }
}

TableList.propTypes = {
  intl: React.PropTypes.any.isRequired,
  list: React.PropTypes.object.isRequired,
  index: React.PropTypes.number.isRequired,
  onHandleDelete: React.PropTypes.func.isRequired,
  showAnimation: React.PropTypes.bool,
};

TableList.defaultProps = {
  showAnimation: false,
};

export default injectIntl(TableList);




// WEBPACK FOOTER //
// ./src/containers/AccountCenter/coms/ManageView/TableList/index.jsx